import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { IconButton } from '@hub/button';
import { HamburgerMediumIcon } from '@hub/icon';
import { useToken } from '@hub/design-system-base';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const HamburgerButton = ({
  onToggle,
  menuId,
  expanded,
  sx
}) => {
  const hitTargetGrowthX = useToken('space', 'spacing-sm');
  const HamburgerIconButtonAs = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    "aria-controls": menuId,
    "aria-owns": menuId,
    "aria-expanded": expanded
  }, props), {}, {
    ref: ref
  })));
  HamburgerIconButtonAs.displayName = 'HamburgerIconButtonAs';
  return /*#__PURE__*/_jsx(IconButton, {
    as: HamburgerIconButtonAs,
    icon: /*#__PURE__*/_jsx(HamburgerMediumIcon, {
      boxSize: "size-icon-md"
    }),
    "aria-label": "Open Secondary Navigation",
    sx: _objectSpread(_objectSpread({}, sx), {}, {
      position: 'relative',
      backgroundColor: 'transparent',
      minWidth: 'initial',
      // Increase the hit target of the button
      '&:before': {
        content: '""',
        position: 'absolute',
        left: "-".concat(hitTargetGrowthX),
        right: "-".concat(hitTargetGrowthX),
        top: 0,
        bottom: 0
      }
    }),
    onClick: onToggle
  });
};